import { ROUTES, SOCIAL_LINKS } from '@/constants'

export type FooterLink = {
  label: string
  href: string
  external?: boolean
}

export type FooterSection = {
  id: string
  heading: string
  links: readonly FooterLink[]
}

export const FOOTER_CTA = {
  heading: 'Join our Directory',
  buttons: [
    { label: "I'm a Supplier", href: '/supplier-pricing' },
    { label: "I'm a Venue", href: '/venue-pricing' },
  ],
} as const

export const FOOTER_SECTIONS: readonly FooterSection[] = [
  {
    id: 'venues-suppliers',
    heading: 'Wedding Venues & Suppliers',
    links: [
      { label: 'Find Wedding Suppliers', href: '/wedding-suppliers' },
      { label: 'Explore Wedding Venues', href: '/wedding-venues' },
      {
        label: 'Submissions',
        href: 'https://docs.google.com/forms/d/1mzNnEEfcJI-Nl1odd7je8VvCYSoW6IzcC1Z5EetfNsQ/',
        external: true,
      },
      { label: 'Work With Us', href: `${ROUTES.ABOUT_US}#work-with-us` },
    ],
  },
  {
    id: 'planning-inspiration',
    heading: 'Planning & Inspiration',
    links: [
      { label: 'Wedding Planning', href: '/wedding-planning' },
      { label: 'Wedding Inspiration', href: '/wedding-inspiration' },
      { label: 'Engagement', href: '/engagement' },
      { label: 'Competitions', href: '/competitions' },
    ],
  },
  {
    id: 'fashion-beauty-lifestyle',
    heading: 'Fashion, Beauty & Lifestyle',
    links: [
      { label: 'Wedding Fashion', href: '/fashion' },
      { label: 'Wedding Beauty', href: '/beauty' },
      { label: 'Honeymoons & Travel', href: '/travel' },
      { label: 'Wedding Gifts', href: '/gifts' },
    ],
  },
] as const

export const FOOTER_UTILITY_LINKS: readonly FooterLink[] = [
  { label: 'About us', href: ROUTES.ABOUT_US },
  { label: 'Terms & Conditions', href: ROUTES.TERMS },
  { label: 'Privacy Policy', href: ROUTES.PRIVACY },
] as const

export const FOOTER_SOCIALS = [
  { name: 'Instagram', href: SOCIAL_LINKS.INSTAGRAM },
  { name: 'TikTok', href: SOCIAL_LINKS.TIKTOK },
  { name: 'Facebook', href: SOCIAL_LINKS.FACEBOOK },
  { name: 'Pinterest', href: SOCIAL_LINKS.PINTEREST },
] as const

// Google "Add as a preferred source" follow URL.
// Format documented at: https://developers.google.com/search/docs/appearance/preferred-sources
export const GOOGLE_PREFERRED_SOURCE_URL =
  'https://google.com/preferences/source?q=rockmywedding.co.uk'
